import { Component, OnInit } from '@angular/core';
import { AnalysisService } from '../../analysis.service';
import { LOCAL_STORAGE_KEYS } from 'src/app/shared/constants/storage-keys';

@Component({
    selector: 'tdms-select-viz',
    templateUrl: './select-viz.component.html',
    styleUrls: ['./select-viz.component.scss'],
    standalone: false
})
export class SelectVizComponent implements OnInit {

  geoCardCheck = false;
  tmCardCheck = false;
  saCardCheck = false;

  constructor(private analysisService: AnalysisService) { }

  ngOnInit() {
    this.loadCardSelection();
  }

  toggleGeoCardSelection(checked: boolean) {
    console.log('toggleGeoCardSelection ---> '+checked);
    this.geoCardCheck = checked;
    this.storeCardSelection();
    this.emmitCardSelection();
  }

  toggleTmCardSelection(checked: boolean) {
    console.log('toggleTmCardSelection ---> '+checked);
    this.tmCardCheck = checked;
    this.storeCardSelection();
    this.emmitCardSelection();
  }

  toggleSaCardSelection(checked: boolean) {
    console.log('toggleSaCardSelection ---> '+checked);
    this.saCardCheck = checked;
    this.storeCardSelection();
    this.emmitCardSelection();
  }

  emmitCardSelection() {
    this.analysisService.setVizCardSelection(this.geoCardCheck || this.tmCardCheck || this.saCardCheck);
  }

  private storeCardSelection() {
    const obj = {'geoCardSelection': this.geoCardCheck, 'tmCardSelection': this.tmCardCheck, 'saCardSelection': this.saCardCheck};
    localStorage.setItem(LOCAL_STORAGE_KEYS.VIZ_CARD_SELECTION, JSON.stringify(obj));
  }

  private loadCardSelection() {
    const obj = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIZ_CARD_SELECTION));

    this.geoCardCheck =  obj !==null ? obj.geoCardSelection : true;
    this.tmCardCheck =   obj !==null ? obj.tmCardSelection : true;
    this.saCardCheck =   obj !==null ? obj.saCardSelection : true;
  }

}
